export default __webpack_public_path__ + "static/media/detailed-info.007d36bc.svg";